import { defineMessages } from 'react-intl';

export const messages: {
	exploreRovodevHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreRovodevDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	understandRovodevHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	understandRovodevDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nextButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	backButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	readMoreButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	progressIndicator: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	exploreRovodevHeading: {
		defaultMessage: 'Start coding with Rovo Dev in Jira',
		description: 'Heading for the first spotlight step about Rovo Dev',
		id: 'acrabats.rovo-dev-spotlight.explore-rovo-dev.heading',
	},
	exploreRovodevDescription: {
		defaultMessage:
			"Get started on this work item using Rovo Dev to generate code. It's work is only visible to you.",
		description: 'Description for the first spotlight step about Rovo Dev',
		id: 'acrabats.rovo-dev-spotlight.explore-rovo-dev.description',
	},
	understandRovodevHeading: {
		defaultMessage: 'You review and approve',
		description: 'Heading for the second spotlight step about Rovo Dev',
		id: 'acrabats.rovo-dev-spotlight.understand-rovo-dev.heading',
	},
	understandRovodevDescription: {
		defaultMessage:
			"Once the agent has finished, you're in control of approving the work and sharing with your team.",
		description: 'Description for the second spotlight step about Rovo Dev',
		id: 'acrabats.rovo-dev-spotlight.understand-rovo-dev.description',
	},
	nextButton: {
		defaultMessage: 'Next',
		description: 'Button to go to the next spotlight step',
		id: 'acrabats.rovo-dev-spotlight.navigation.next',
	},
	backButton: {
		defaultMessage: 'Back',
		description: 'Button to go back to the previous spotlight step',
		id: 'acrabats.rovo-dev-spotlight.navigation.back',
	},
	readMoreButton: {
		defaultMessage: 'Read more',
		description: 'Link to read more documentation about Rovo Dev',
		id: 'acrabats.rovo-dev-spotlight.navigation.read-more',
	},
	progressIndicator: {
		defaultMessage: '{currentStep} of {totalSteps}',
		description: 'Progress indicator showing current step and total steps',
		id: 'acrabats.rovo-dev-spotlight.navigation.progress',
	},
});
